<template>
  <div itemscope itemtype="http://schema.org/Service">
    <meta itemprop="serviceType" content="Softwareentwicklung" />
   <v-container>
     <v-layout row wrap>
       <v-flex xs12>
         <v-card >
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             alt="softwareentwicklung"
             height="450px"
             :src="require('../assets/Softwareentwicklung.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox positionsofteware>
                   <div itemprop="name">
                   <span class="edoheadlinesoftware">INDIVIDUELLE SOFTWAREENTWICKLUNG</span>
                   </div>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
       <div>
         <v-breadcrumbs divider=">" class="edobread">
           <v-breadcrumbs-item
             v-for="item in items"
             :key="item.text"
             :disabled="item.disabled"
           >
             <a :href='item.route'>{{ item.text }}</a>
           </v-breadcrumbs-item>
         </v-breadcrumbs>
       </div>
     </v-layout>
       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm8 md8>
             <v-card class="edomargintop" flat>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Durch unsere innovativen Fertigkeiten verwirklichen wir Ihre individuelle Softwarelösung – perfekt auf Sie abgestimmt.
                 <br><br>
                 Die edologic ist immer darauf bedacht, Sie mit Ihren Produkten optimal zu unterstützen, in dem Sie ökonomische und bedienungsfreundlicher arbeiten können.
                 <br><br>
                 Um Sie von Anfang an perfekt zu betreuen, beginnt jede Entwicklung mit einer sorgfältigen Anforderungsanalyse.
                 <br><br>
                 Mit der edologic können Sie zu jeder Zeit auf Umwelteinflüsse reagieren und agieren, denn unser langjähriges Experten Team steht Ihnen zur Seite und setzt Ihre Anpassungen flexibel, schnell und zielorientiert um.
                 <br><br>
                 Starten Sie mit der edologic durch und erhalten die Software, die auf Sie maßgeschneidert ist und nicht nur zu Ihnen passt.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder">
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm2 md2>
           <v-card class="edomargintop">
             <v-card-text class="edoLineText">
               • Java <br>
               • .NET Framework <br>
               • ASP.NET <br>
               • C#
             </v-card-text>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm2 md2>
           <v-card class="edomargintop">
             <v-card-text class="edoLineText">
               • Cappuccino <br>
               • CSS <br>
               • HTML <br>
               • JavaScript
             </v-card-text>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm2 md2>
           <v-card class="edomargintop">
             <v-card-text class="edoLineText">
               • MS SQL <br>
               • MySQL  <br>
               • Orient DB <br>
               • u.v.m. ...
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder">
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex xs12 sm12 md12>
           <v-card>
             <v-card-media
               class="edomargintop hidden-xs-only"
               height="500px"
               :src="require('../assets/Referenzen_big.jpg')">
             </v-card-media>
             <v-card-media
               class="edomargintop hidden-sm-and-up"
               height="250px"
               :src="require('../assets/Referenzen_big.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
     </v-container>
  </div>
</template>

<script>

  export default {
    components: {},
    name: 'Softwareentwicklung',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Softwareentwicklung – agil und individuell',
      meta: [
        {
          name: 'description',
          content: 'Maßgeschneiderte, auf Sie angepasste Softwareentwicklung – perfekt auf Sie abgestimmt'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Service',
          route: '/service',
          disabled: false
        },
        {
          text: 'Softwareentwicklung',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
    },
    mounted () {
      console.log('Softwareentwicklung')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Softwareentwicklung.vue